
import React, { FC } from "react";
import { Col, Row, Skeleton } from "antd";
import EmptyState from "../../../../../shared/components/EmptyState";
import moment from "moment";

//model
import { Subscription } from "../../../../../models/SubscriptionModel/subscription.model";

interface PurchaseHistoryProps {
    data: Subscription[];
}

const PurchaseHistory: FC<PurchaseHistoryProps> = (props) => {
    const { data } = props;


    return (
        <>
            <div className='details__title'>  Purchase History</div>
            {data.length
                ? <Row gutter={[16, 24]} >
                    {data.map((data: any, i: number) => (
                        <Col span={24} className="subscription__details history">
                            <div className="subscription-details__wrapper">
                                <Row className="subscription-institute-details__wrapper">
                                    <Col span={8}>
                                        <div className="subscription-instiute__details">
                                            <p className="subscription__date">{data?.name}</p>
                                            <p >{data?.boardName}</p>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="subscription-instiute__details">
                                            <p >{'Subscribed on'}</p>
                                            <p className="subscription__date">{moment(data?.startDate).format('MMM DD,YYYY')}</p>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="subscription-instiute__details">
                                            <p >{'Valid until'}</p>
                                            <p className="subscription__date">{moment(data?.endDate).format('MMM DD,YYYY')}</p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    ))
                    }
                </Row>
                : <EmptyState text={'No subscriptions found.'} />
            }
        </>
    )
}

export default PurchaseHistory;



